'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import WarningIcon from './WarningIcon';

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

const defaultProps = {
    children: null,
    className: '',
}

function WarningBox(props) {
    return (
        <div className={`error-box alert alert-warning ${props.className}`} role="alert">
            <WarningIcon className="margin-right-sm" />
            <span className="sr-only">Warning:</span>
            <span>{props.children}</span>
        </div>
    );
}

WarningBox.propTypes = propTypes;
WarningBox.defaultProps = defaultProps

export default WarningBox;